import {memo} from 'react';

import Grid from '@mui/material/Grid';
import {useMeasure} from '@uidotdev/usehooks';
import {number} from 'prop-types';
import {useLocation} from 'react-router-dom';

import useSidebarReports from '../../../hooks/components/main-sidebar/useSidebarReports';
import useMainSidebar from '../../../hooks/providers/useMainSidebar';
import useReport from '../../../hooks/providers/useReport';
import {calculateNeededSpaceForSidebarCards} from '../../../utils';
import OpenMoreReportsOrModulesPopperButton from '../OpenMoreReportsOrModulesButton/OpenMoreReportsOrModulesButton';
import SidebarSeparatorShadow from '../SidebarSeparatorShadow/SidebarSeparatorShadow';
import SingleReportCard from '../SingleReportCard/SingleReportCard';

const ReportsList = ({maxHeight}) => {
  const {sidebarReports, reportsListContainerRef: containerRef, reportsListContainerHeight: containerHeight} = useMainSidebar();
  const {reports} = useReport();
  const location = useLocation();

  const canDisplayAllReports = calculateNeededSpaceForSidebarCards(reports.length) <= containerHeight;
  const isReportPage = location.pathname.startsWith('/reports');

  useSidebarReports(containerHeight, canDisplayAllReports);

  return (
    <Grid
      height={isReportPage && '100%'}
      maxHeight={maxHeight}
      pb={1.5}
      pt={1}
      sx={{
        position: 'relative'
      }}
      ref={containerRef}
      container
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      flexWrap="nowrap"
      display="flex"
      flex="auto"
    >
      {(sidebarReports || []).map(r => (
        <SingleReportCard key={r.report_id} isDisplayedInMoreReportsPopper={false} report={r} />
      ))}

      <OpenMoreReportsOrModulesPopperButton canDisplayAllItems={canDisplayAllReports} isMoreReportsButton />

      {isReportPage ? <SidebarSeparatorShadow isAbsolutePositionned /> : null}
    </Grid>
  );
};

ReportsList.propTypes = {
  maxHeight: number.isRequired
};

export default memo(ReportsList);
